import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
interface MesoAdsInformationProps {
  slots: string[];
}

export const MesoAdsInformation = ({ slots }: MesoAdsInformationProps) => {
  return (
    <section className="uitk-cell uitk-type-center all-y-margin-three">
      <ErrorBoundary label="meso.display.ad">
        {slots.map((slot, index) => (
          <meso-display-ad uci={slot} slot={slot} key={`mesoDisplayAd${index}`} />
        ))}
      </ErrorBoundary>
    </section>
  );
};

export const cmAds = {
  CM1: 'CM1',
  CM2: 'CM2',
  CM4: 'CM4'
};
